//Reset data
export const RESET = "INSTITUTIONTYPE_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "INSTITUTIONTYPE_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "INSTITUTIONTYPE_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "INSTITUTIONTYPE_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "INSTITUTIONTYPE_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "INSTITUTIONTYPE_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "INSTITUTIONTYPE_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "INSTITUTIONTYPE_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "INSTITUTIONTYPE_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "INSTITUTIONTYPE_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "INSTITUTIONTYPE_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "INSTITUTIONTYPE_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "INSTITUTIONTYPE_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "INSTITUTIONTYPE_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "INSTITUTIONTYPE_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "INSTITUTIONTYPE_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "INSTITUTIONTYPE_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "INSTITUTIONTYPE_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "INSTITUTIONTYPE_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "INSTITUTIONTYPE_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "INSTITUTIONTYPE_DEL_SET_IS_UPDATE"